<template>
	<app-title-bar :icon="['fas', 'clipboard-check']" subtitle="Product Data" title="Review Documents">
		<app-button to="/product-data/product-categories" icon="fa-circle-left">Back</app-button>
	</app-title-bar>

	<app-panel :title="`${documents.length} document${documents.length === 1 ? '' : 's'} awaiting review`">
		<p v-if="!canReview" class="mb-4 text-sm text-gray-500">
			You can view outstanding documents, but you must have the Document Reviewer role
			to approve or reject them.
		</p>
		<documents-table
			:documents="documents"
			:loading="loading"
			:readonly="true"
			:show-business-unit-column="true"
			@refresh-documents="load" />
	</app-panel>
</template>

<script lang="ts" setup>
	import { computed, onMounted, ref } from 'vue'
	import AppPanel from '@/components/layout/panel/AppPanel.vue'
	import DocumentsTable from '@/components/datatables/all/DocumentsTable.vue'
	import DocumentService from '@/services/document'
	import useAuthStore from '@/stores/auth'

	const documents = ref<any[]>([])
	const loading = ref(true)
	const authStore = useAuthStore()
	const canReview = computed(() => authStore.isAbleTo(['review_documents']))

	const load = async () => {
		loading.value = true
		try {
			const response = await new DocumentService().requiringApproval()
			const data = response.data?.data ?? response.data ?? []
			documents.value = Array.isArray(data) ? data : []
		} catch (error) {
			console.error('Error fetching documents requiring approval:', error)
			documents.value = []
		} finally {
			loading.value = false
		}
	}

	onMounted(load)
</script>
